import React from "react";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { Link } from "react-router-dom";
import "./Notification.css";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";

const Notification = () => {
  return (
    <div className="notification" >

      <h4 className="mb-5 semibold">My Notifications</h4>


      <div className="notification_today">
        <h5 >Today</h5>
        <div className="d-flex flex-wrap align-items-center justify-content-between notification-bg mt-3 p-3">
          <div className="d-flex flex-wrap">
            <div className="me-3 icon-notification">
              <InboxOutlinedIcon />
            </div>
            <div>
              <p className="cl-pm">Email Verification</p>
              <p className="text-wrap">
                Hello, This is time to verify your account. Access your mail account
                and verify.
                <Link to="/" className="cl-pm ms-2">
                  Click Here
                </Link>
              </p>
            </div>
          </div>
          <div className="notification-delete">
            <p>2:29 pm</p>
            <DeleteOutlineOutlinedIcon className="cursor" />
          </div>
        </div>

        <div className="d-flex flex-wrap align-items-center justify-content-between notification-bg mt-3 p-3">
          <div className="d-flex flex-wrap">
            <div className="me-3 icon-notification">
              <BookmarkBorderOutlinedIcon />
            </div>
            <div>
              <p className="cl-pm">Success Registered</p>
              <p>Congrates! You have registered successfully.</p>
            </div>
          </div>
          <div className="notification-delete">
            <p>2:29 pm</p>
            <DeleteOutlineOutlinedIcon className="cursor" />
          </div>
        </div>
      </div>

      <hr />

      <div className="notification_yesterday">
        <h5>Yesterday</h5>
        <div className="d-flex flex-wrap align-items-center justify-content-between notification-bg mt-3 p-3">
          <div className="d-flex flex-wrap">
            <div className="me-3 icon-notification">
              <InboxOutlinedIcon />
            </div>
            <div>
              <p className="cl-pm">Email Verification</p>
              <p className="text-wrap">
                Hello, This is time to verify your account. Access your mail account
                and verify.
                <Link to="/" className="cl-pm ms-2">
                  Click Here
                </Link>
              </p>
            </div>
          </div>
          <div className="notification-delete">
            <p>2:29 pm</p>
            <DeleteOutlineOutlinedIcon className="cursor" />
          </div>
        </div>

        <div className="d-flex flex-wrap align-items-center justify-content-between notification-bg mt-3 p-3">
          <div className="d-flex flex-wrap">
            <div className="me-3 icon-notification">
              <BookmarkBorderOutlinedIcon />
            </div>
            <div>
              <p className="cl-pm">Success Registered</p>
              <p>Congrates! You have registered successfully.</p>
            </div>
          </div>
          <div className="notification-delete">
            <p>2:29 pm</p>
            <DeleteOutlineOutlinedIcon className="cursor" />
          </div>
        </div>
      </div>

      <hr />

      <div className="notification_specificDate">
        <h5>29 Jan 2021</h5>
        <div className="d-flex flex-wrap align-items-center justify-content-between notification-bg mt-3 p-3">
          <div className="d-flex flex-wrap">
            <div className="me-3 icon-notification">
              <InboxOutlinedIcon />
            </div>
            <div>
              <p className="cl-pm">Email Verification</p>
              <p className="text-wrap">
                Hello, This is time to verify your account. Access your mail account
                and verify.
                <Link to="/" className="cl-pm ms-2">
                  Click Here
                </Link>
              </p>
            </div>
          </div>
          <div className="notification-delete">
            <p>2:29 pm</p>
            <DeleteOutlineOutlinedIcon className="cursor" />
          </div>
        </div>

        <div className="d-flex flex-wrap align-items-center justify-content-between notification-bg mt-3 p-3">
          <div className="d-flex flex-wrap">
            <div className="me-3 icon-notification">
              <BookmarkBorderOutlinedIcon />
            </div>
            <div>
              <p className="cl-pm">Success Registered</p>
              <p>Congrates! You have registered successfully.</p>
            </div>
          </div>
          <div className="notification-delete">
            <p>2:29 pm</p>
            <DeleteOutlineOutlinedIcon className="cursor" />
          </div>
        </div>
      </div>

      <hr />
      
    </div>
  );
};

export default Notification;
